"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var types_1 = require("../../../../types");
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var Step2 = function (_a) {
    var type = _a.type, confirmSetLimit = _a.confirmSetLimit, setPrevStep = _a.setPrevStep, limitAmount = _a.limitAmount, limitDuration = _a.limitDuration, isSubmitting = _a.isSubmitting;
    var t = (0, next_intl_1.useTranslations)('translation');
    var title = (0, react_1.useMemo)(function () {
        return type === types_1.LimitType.BET
            ? t('wageringLimit')
            : types_1.LimitType.LOSS
                ? t('lossLimit')
                : t('depositLimit');
    }, [type, t]);
    var description = (0, react_1.useMemo)(function () {
        return type === types_1.LimitType.BET
            ? t('doYouReallyWantSetWageringLimit')
            : types_1.LimitType.LOSS
                ? t('doYouReallyWantSetLossLimit')
                : t('doYouReallyWantSetDepositLimit');
    }, [type, t]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, description),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContent },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContentRow },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContentTitle }, t('limitAmount')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContentValue }, limitAmount)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContentRow },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContentTitle }, t('limitDuration')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.confirmationContentValue }, limitDuration))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.disclaimer }, t('onceConfirmedCannotEdited')),
        react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", onClick: confirmSetLimit, maxWidth: "335px", width: "100%", loading: isSubmitting }, t('confirm')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.backButton, onClick: setPrevStep }, t('cancel'))));
};
exports.default = Step2;
